<template>
  <div class="page-permessi">

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri"
        @click="() => { filtriActive ? closeFiltri() : openFiltri() }">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
      <el-button class="WEB-button WEB-button-icon-transparent right prec" @click="changeYear(-1)">
        <icon name="riv-arrow" scale="1.2" flip="horizontal"></icon>
      </el-button>
      <span class="titolo">{{ this.filtro.anno }}</span>
      <el-button class="WEB-button WEB-button-icon-transparent right prec" @click="changeYear(1)">
        <icon name="riv-arrow" scale="1.2"></icon>
      </el-button>
      <el-button class="WEB-button WEB-button-primary" style="float: right" @click="inviaPDF()">
        {{ $t('delSind.btn.pdf').toUpperCase() }}
      </el-button>
      <el-button class="WEB-button WEB-button-primary" style="float: right" @click="() => {
        this.richiesta = {
          data: '',
          descrizione: '',
          gestibile: '',
          idRic: '',
          oraFin: '',
          oraIni: '',
          oreLav: 'N',
          checkedOre: false,
          tipoAssenza: '',
          residuo: ''
        }
        this.showModalRichiesta = true
      }">
        {{ $t('delSind.nuovaRichiesta').toUpperCase() }}
      </el-button>
    </div>

    <div class="WEB-body col-24 no-padding">

      <!-- Filtri -->
      <div class="WEB-filtri" v-show="filtriActive">
        <div class="WEB-filtri-content">
          <div class="row">
            <!--<div class="WEB-filtri-title col-24">
              {{$t('filtri.selFiltri')}}
            </div>-->
            <div class="WEB-filtri-label col-24">
              {{ $t('delSind.anno') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.anno" class="WEB-select" value-key="anno">
                <el-option v-for="item in anni" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('delSind.tipologie') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.tipoAssenza" class="WEB-select" value-key="tipoAssenza">
                <el-option v-for="item in tipiAssenza" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('delSind.oreLav') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.oreLav" class="WEB-select" value-key="oreLav">
                <el-option v-for="item in oreLav" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="filtri-footer row">
          <div class="col-12 filtri-button-sx">
            <el-button class="WEB-button WEB-button-alternative" @click="svuotaCampi()">
              {{ $t('btn.svuotaCampi') }}
            </el-button>
          </div>
          <div class="col-12 filtri-button-dx">
            <el-button class="WEB-button WEB-button-primary central" @click="cerca()">
              {{ $t('btn.cerca') }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="mask-div" v-show="filtriActive" @click="closeFiltri" />
      <!-- END Filtri -->


      <el-table :data="permessi" highlight-current-row width="100%" v-loading="loading" class="custom-table table-ferie"
        :height="100 % - 56 - 60 - 83">

        <el-table-column prop="descrizione" header-align="center" :label="($t('delSind.tipologia'))" min-width="200">
        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('delSind.dt_creazione'))" width="120">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.idRic | getCreationDate }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('delSind.periodo'))" width="250">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.data | formatDate }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('delSind.orario'))" width="140">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.oraIni + ' - ' + scope.row.oraFin }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('delSind.numOre'))" width="140">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.oreAssenza ? scope.row.oreAssenza : ' ' }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('delSind.oreLavCell'))" width="140">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.oreLav }}
            </div>
          </template>

        </el-table-column>

        <el-table-column align="center" header-align="center" width="50">

          <template slot-scope="scope">
            <div class="actions">
              <icon v-if="(scope.row.gestibile === 'Y')" class="pointer" name="riv-prenotazione" scale="1.1"
                @click.native="() => {
                  openModalRichiesta(scope.row)
                }"></icon>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" header-align="center" width="50">

          <template slot-scope="scope">
            <div class="actions">
              <icon v-if="(scope.row.gestibile === 'Y')" class="pointer" name="riv-delete2" scale="1.1"
                @click.native="deleteRichiesta(scope.row)"></icon>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination class="custom-pagination" v-if="(nrItems > pag_for)" layout="prev, pager, next"
        :current-page="currentPage" :total="nrItems" :page-size="pag_for" @current-change="changePage">
      </el-pagination>
    </div>

    <!-- MODAL INSERIMENTO RICHIESTA -->
    <el-dialog :title="($t('delSind.titoloNuovaRichiestaPermesso').toUpperCase())" :visible.sync="showModalRichiesta"
      class="custom-dialog" :append-to-body="true" custom-class="offset-7 col-10">
      <el-form class="">
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('delSind.tipologia') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="richiesta.tipoAssenza" @change="getResiduo">
              <el-option v-for="item in tipiAssenza" :key="item.codice" :label="item.descrizione" :value="item.codice">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('delSind.giorno') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-date-picker @change="getResiduo" class="dt-picker" v-model="richiesta.data" type="date"
              format="dd/MM/yyyy" value-format="yyyyMMdd" placeholder="" :picker-options="{
                firstDayOfWeek: 1
              }">
            </el-date-picker>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('delSind.residuo') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-input type="text" placeholder="" v-model="richiesta.residuo" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('delSind.oraInizio') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select @change="changeOre" v-model="richiesta.oraIni" :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="col-2 no-padding" style="text-align: center">
            {{ $t('delSind.to') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select @change="changeOre" v-model="richiesta.oraFin" :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="col-4 no-padding" style="text-align: center">
            {{ $t('delSind.numOre') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select v-model="richiesta.oreAssenza" :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('delSind.oreLav') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-checkbox v-model="richiesta.checkedOre" class="riva-header-checkbox"></el-checkbox>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="() => {
          this.$set(this, 'richiesta', '')
          this.showModalRichiesta = false
        }">
          {{ $t('btn.annulla') }}
        </el-button>
        <el-button class="WEB-button WEB-button-primary" @click="setRichiesta">
          {{ $t('btn.conferma').toUpperCase() }}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ElencoPermessi',
  props: ['tableHeight'],
  data() {
    return {// filtri
      filtriActive: false,
      filtro: {
        anno: 0,
        tipoAssenza: '',
        oreLav: ''
      },
      country: "",
      loading: false,
      permessi: [],
      currentPage: 1,
      pag_for: 100,
      anni: [],
      //countries: [],
      tipiAssenza: [],
      oreLav: ['', 'Y', 'N'],
      nrItems: 0,
      richiesta: {
        data: '',
        descrizione: '',
        gestibile: '',
        idRic: '',
        oraFin: '',
        oraIni: '',
        oreAssenza: '',
        oreLav: 'Y',
        checkedOre: false,
        tipoAssenza: '',
        residuo: ''
      },
      showModalRichiesta: false,
    }
  },
  filters: {
    formatDate: function (date) {
      return date !== '' ? moment(date, "YYYYMMDD").format("DD/MM/YYYY") : ''
    },
    getCreationDate: function (id) {
      if (id === undefined || id === '' || id.length < 10) {
        return ''
      } else {
        return moment(id, "YYYY-MM-DD").format("DD/MM/YYYY")
      }
    }
  },
  activated: function () {
    this.country = this.$store.state.country
    let anno = new Date().getFullYear()
    this.$set(this.filtro, 'anno', anno)
    this.anni = [anno - 1, anno, anno + 1]
    this.getTipologie()
    this.ricerca()
    //this.getCountries()
  },
  deactivated: function () {
    this.country = ""
    this.filtriActive = false
    this.loading = false
    let filtro = {
      anno: 0,
      tipoAssenza: '',
      oreLav: ''
    }
    this.$set(this, 'filtro', filtro)
    this.$set(this, 'permessi', [])
    this.currentPage = 1
    this.pag_for = 100
    let richiesta = {
      data: '',
      descrizione: '',
      gestibile: '',
      idRic: '',
      oraFin: '',
      oraIni: '',
      oreAssenza: '',
      oreLav: 'N',
      checkedOre: false,
      tipoAssenza: '',
      residuo: ''
    }
    this.$set(this, 'richiesta', richiesta)
    this.$set(this, 'anni', [])
    this.$set(this, 'tipiAssenza', [])
    this.$set(this, 'oreLav', ['', 'Y', 'N'])
    this.nrItems = 0
    this.showModalRichiesta = false
  },
  methods: {
    // GESTIONE FILTRI
    openFiltri: function () {
      this.filtriActive = true
    },
    closeFiltri: function () {
      this.filtriActive = false
    },
    svuotaCampi: function () {
      this.$set(this.filtro, 'tipoAssenza', '')
      this.$set(this.filtro, 'oreLav', '')
    },
    changeYear: function (value) {
      this.$set(this.filtro, 'anno', this.filtro.anno + value)
      this.currentPage = 1
      this.ricerca()
    },
    cerca: function () {
      this.currentPage = 1
      this.filtriActive = false
      this.ricerca()
    },
    // END GESTIONE FILTRI
    openModalRichiesta: function (rich) {
      let richiesta = {
        data: rich.data,
        descrizione: rich.descrizione,
        gestibile: rich.gestibile,
        idRic: rich.idRic,
        oraFin: rich.oraFin,
        oraIni: rich.oraIni,
        oreAssenza: rich.oreAssenza,
        oreLav: rich.oreLav,
        checkedOre: rich.oreLav === 'Y' ? false : true,
        tipoAssenza: rich.tipoAssenza,
        residuo: ''
      }
      this.$set(this, 'richiesta', richiesta)
      this.showModalRichiesta = true
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca()
    },
    change: function () {
      this.ricerca()
    },
    getTipologie: function () {
      this.tipiAssenza = []
      this.$http.get("deleghesindacali/" + this.country + '/tipologie', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          seCedibili: ''
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.tipiAssenza = response.body.data
            this.tipiAssenza.unshift({
              codice: "",
              descrizione: ''
            })
          }
        })
    },
    ricerca: function () {
      this.loading = true
      this.$http.get('deleghesindacali/' + this.country + '/permessi', {
        params: {
          pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
          pag_for: this.pag_for,
          pag_from: this.currentPage,
          anno: this.filtro.anno,
          tipoAssenza: this.filtro.tipoAssenza,
          oreLav: this.filtro.oreLav
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'permessi', response.body.data)
            if (this.currentPage === 1) {
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$set(this, 'permessi', [])
            this.currentPage = 1
            this.nrItems = 0
          }
          this.loading = false
        })
    },
    setRichiesta: function () {
      let data = {
        idRic: this.richiesta.idRic,
        operazione: this.richiesta.idRic === '' ? "*ADD" : "*UPD",
        data: this.richiesta.data,
        oraIni: this.richiesta.oraIni,
        oraFin: this.richiesta.oraFin,
        oreAssenza: this.richiesta.oreAssenza,
        tipoAssenza: this.richiesta.tipoAssenza,
        oreLav: this.richiesta.checkedOre ? 'N' : 'Y'
      }
      this.$http.post('deleghesindacali/' + this.country + '/fruizionepermessi', data, {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.showModalRichiesta = false
            this.ricerca()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    deleteRichiesta: function (richiesta) {
      this.$confirm(this.$i18n.t('delSind.ifDelete'), this.$i18n.t('delSind.attenzione'), {
        confirmButtonText: this.$i18n.t('btn.elimina'),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'warning'
      }).then(() => {
        this.elimina(richiesta)
      }).catch(() => {
        // Eventuale handler di annullamento cancellazione
      })
    },
    elimina: function (richiesta) {
      this.$http.delete('deleghesindacali/' + this.country + '/fruizionepermessi', {
        params: {
          id: richiesta.idRic,
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.$set(this, 'currentPage', 1)
            this.ricerca()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    inviaPDF: function () {
      this.tipiAssenza = []
      this.$http.get("deleghesindacali/" + this.country + '/print', {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    changeOre: function () {
      if (this.richiesta.oraIni !== '' && this.richiesta.oraFin !== '') {
        var startTime = moment(this.richiesta.oraIni, 'HH:mm');
        var endTime = moment(this.richiesta.oraFin, 'HH:mm');

        // calculate total duration
        var duration = moment.duration(endTime.diff(startTime));

        // duration in hours
        var hours = parseInt(duration.asHours());
        //if (hours >= 8) {
        //  this.$set(this.form, 'oreAssenza', '08:00')
        //} else {
        hours = hours < 10 ? '0' + hours : hours
        var minutes = parseInt(duration.asMinutes()) % 60;
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        this.$set(this.richiesta, 'oreAssenza', hours + ':' + minutes)
        //}
      }
    },
    getResiduo: function () {
      if (this.richiesta.tipoAssenza !== '' && this.richiesta.data !== '') {
        this.$http.get("deleghesindacali/" + this.country + '/residuo', {
          params: {
            codLang: sessionStorage.getItem('codLang'),
            data: this.richiesta.data,
            tipoAssenza: this.richiesta.tipoAssenza
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.richiesta, 'residuo', response.body.data.residuo)
            } else {
              this.$set(this.richiesta, 'residuo', '')
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      } else {
        this.$set(this.richiesta, 'residuo', '')
      }
    },
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

.page-permessi {
  .WEB-actions {
    .prec {
      padding-right: 20px;
      float: none;
    }

    .succ {
      padding-right: 20px;
      float: none;
    }

    .el-date-editor {
      .el-input__inner:hover {
        cursor: pointer;
      }

      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 25px;
        padding-right: 10px;
        width: 150px;
        text-align: center;
      }

      .el-input__prefix {
        left: -5px;

        .el-input__icon {
          line-height: 22px;
        }
      }
    }

    .el-select {

      //margin-left: 20px;
      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 0px;
        padding-right: 10px;
      }

      .el-input__suffix {
        right: -5px;
      }
    }

    .el-checkbox {
      .el-checkbox__inner {
        border-radius: 0px;
      }

      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }

    .header-label {
      .set-font(@size: 14px; @weight: bold);
    }

    .header-value {
      .set-font(@size: 14px; @color: #666);
    }

    .action {
      float: right;
      text-align: right;
    }
  }

  .table-ferie {
    margin-top: 20px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px) - MArgin-top (10px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px - 10px);
  }
}

.autorizzazioni-ferie {
  height: 100%;
  padding: 0;

  .riepilogo {
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;

    .elemento {
      line-height: 40px;

      .titolo {
        height: 60px;
        line-height: 30px;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
      }

      .my-label {
        text-align: left;
        .set-font(@size: 14px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
      }

      .my-value {
        text-align: right;
        .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');

        .el-select {
          .el-input__inner {
            height: 22px;
            line-height: 22px;
            border: 0px;
            border-bottom: 1px solid #e7e7e7;
            border-radius: 0px;
            padding-left: 0px;
            padding-right: 10px;
          }

          .el-input__suffix {
            right: -5px;
          }
        }

        .anno {
          .el-select {
            .el-input__inner {
              width: 55px;
            }
          }
        }

        .stato {
          .el-select {
            width: 90%;
          }
        }
      }
    }
  }

  .elenco {
    height: calc(100vh - 56px - 66px);
    padding: 10px;

    .box {
      padding-top: 10px;
      overflow: auto;
      background-color: #f2f2f2;
      border-radius: 5px;

      .action {
        height: 80px;

        .filter {
          margin-top: 10px;
          text-align: left;
          line-height: 40px;

          .iconArrow {
            cursor: pointer;
            display: inline-block;
            position: relative;
            top: -2px;
            .set-font(@color: @oroRiva, @weight: bold, @family: 'os-regular');
          }

          span {
            .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
          }
        }
      }

      .el-table {
        background-color: #f2f2f2;

        .el-table__header {
          thead {
            tr {
              background-color: #f2f2f2;
            }

            th {
              background-color: #f2f2f2;
            }
          }
        }
      }

      .el-table__body {
        .el-table__row {
          background-color: #f2f2f2;
        }

      }
    }

    .table-ferie {
      height: calc(100vh - 56px - 60px - 82px);
    }
  }

  .note {
    padding: 10px 10px 10px 0px;

    .box {
      border: 1px solid #f2f2f2;

      .note-dip,
      .note-resp {
        .my-label {
          text-align: left;
          margin: 10px;
          border-bottom: 2px solid @greenRiva;

          padding-bottom: 5px;
          .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
        }

        .my-value {
          text-align: left;
          margin: 10px;
          .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');
        }

        height: 150px;
      }
    }

  }

}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}
</style>



// WEBPACK FOOTER //
// src/components/DelegheSindacali/ElencoPermessi.vue